// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"fdc28490","592":"19b56ee6","952":"4753aae8"}[chunkId] + ".chunk.js";
};